<app-loader *ngIf="loading" class="absolute w-screen h-screen z-10 bg-white" [loading]="loading"> </app-loader>
<div class='w-full h-[92vh] flex'>
    <!-- LATERAL MENU -->
    <app-split-view-side-head class="w-[5.5rem] h-full flex flex-col" (click)="drawer.toggle()" [type]="'revisions'"></app-split-view-side-head>
    <mat-drawer-container class="" autosize>
        <!-- DRAWER -->
        <mat-drawer #drawer class="w-[35vw]" mode="side" [opened]="true">
            <section class="flex flex-col">
                <!-- INFOS  -->
                <app-proofreading-info [type]="'revisions'"></app-proofreading-info>
                <!-- COMPARE -->
                <app-approval-proofreading-compare></app-approval-proofreading-compare>
            </section>
        </mat-drawer>
        <!-- DRAWER BUTTON -->
        <div *ngIf="drawer.opened" class="w-[4rem] h-full flex justify-center items-center" (click)="drawer.toggle()">
            <button type="button" mat-icon-button><mat-icon>{{ drawer.opened? 'chevron_left' : 'chevron_right' }}</mat-icon></button>
        </div>
    </mat-drawer-container>
    <!-- VIEWER  -->
    <div class='flex-grow h-full' [ngClass]="{'hidden':loading || !revision_url}">
        <button class="cancel-fullscreen w-full " (click)="cancelFullScreen()">
            <span class="flex gap-2 bg-tw-text-disabled text-tw-text-light items-center p-1">
                <mat-icon>fit_screen</mat-icon>
                <span>{{ 'CANCEL_FULLSCREEN' | translate }}</span>
            </span>
        </button>
        <iframe class="w-full h-full" id='approvalRevisionViewLink' loading='lazy'></iframe>
    </div>
    <div class="h-full flex-grow flex justify-center items-center" *ngIf="!revision_url">
        <p>{{ 'SELECT_DOC' | translate}}</p>
    </div>
</div>